import React, { Component } from 'react';
import '../auth.css';

class CodeInput extends Component {
  constructor(props) {
    super(props);
    this.inputRefs = [];
  }

  componentDidMount() {
    // Auto-focus on first input when component mounts
    if (this.inputRefs[0]) {
      this.inputRefs[0].focus();
    }
  }

  handleChange = (index, e) => {
    const value = e.target.value;
    
    // Only allow single digit
    if (value.length > 1) {
      return;
    }

    // Only allow numbers
    if (value && !/^\d$/.test(value)) {
      return;
    }

    const { code, onChange } = this.props;
    const newCode = [...code];
    newCode[index] = value;
    onChange(newCode);

    // Auto-focus next input
    if (value && index < 5) {
      this.inputRefs[index + 1].focus();
    }
  };

  handleKeyDown = (index, e) => {
    const { code, onChange } = this.props;

    // Handle backspace
    if (e.key === 'Backspace') {
      if (!code[index] && index > 0) {
        // If current input is empty, move to previous and clear it
        const newCode = [...code];
        newCode[index - 1] = '';
        onChange(newCode);
        this.inputRefs[index - 1].focus();
      } else if (code[index]) {
        // Clear current input
        const newCode = [...code];
        newCode[index] = '';
        onChange(newCode);
      }
    }

    // Handle left arrow
    if (e.key === 'ArrowLeft' && index > 0) {
      this.inputRefs[index - 1].focus();
    }

    // Handle right arrow
    if (e.key === 'ArrowRight' && index < 5) {
      this.inputRefs[index + 1].focus();
    }
  };

  handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text/plain').trim();
    
    // Only process if it's 6 digits
    if (/^\d{6}$/.test(pastedData)) {
      const newCode = pastedData.split('');
      this.props.onChange(newCode);
      
      // Focus last input
      this.inputRefs[5].focus();
    }
  };

  render() {
    const { code, error, disabled } = this.props;

    // Inline styles to override Bootstrap and global styles
    const wrapperStyle = {
      display: 'flex',
      flexDirection: 'row',
      gap: '12px',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'nowrap',
      width: '100%'
    };

    const inputStyle = {
      width: '52px',
      height: '64px',
      minWidth: '52px',
      maxWidth: '52px',
      minHeight: '64px',
      maxHeight: '64px',
      fontSize: '28px',
      fontWeight: '700',
      textAlign: 'center',
      border: '2px solid #e0e0e0',
      borderRadius: '12px',
      background: '#ffffff',
      color: '#29282D',
      transition: 'all 0.2s ease',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      flexShrink: 0,
      flexGrow: 0,
      flexBasis: '52px',
      caretColor: '#007EA0',
      padding: '0',
      margin: '0',
      boxSizing: 'border-box',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none',
      lineHeight: '64px'
    };

    return (
      <div className="auth-code-input-container" style={{ width: '100%', margin: '24px 0', display: 'block' }}>
        <div className="auth-code-input-wrapper" style={wrapperStyle}>
          {code.map((digit, index) => (
            <input
              key={index}
              ref={(ref) => (this.inputRefs[index] = ref)}
              type="text"
              inputMode="numeric"
              pattern="\d*"
              maxLength="1"
              className={`auth-code-input ${error ? 'error' : ''} ${digit ? 'filled' : ''}`}
              style={inputStyle}
              value={digit}
              onChange={(e) => this.handleChange(index, e)}
              onKeyDown={(e) => this.handleKeyDown(index, e)}
              onPaste={index === 0 ? this.handlePaste : undefined}
              disabled={disabled}
              autoComplete="off"
            />
          ))}
        </div>
        {error && (
          <div className="auth-error auth-mt-sm">
            <span>⚠️</span>
            <span>{error}</span>
          </div>
        )}
      </div>
    );
  }
}

export default CodeInput;